var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loggedIn)?_c('plus-header'):_vm._e(),_vm._v(" "),_c('main',{staticClass:"container-fluid"},[_c('router-view'),_vm._v(" "),_c('dialogs-wrapper',{attrs:{"wrapper-name":"default"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }